export default function (val: any) {
  // Kiem tra co gia tri hay khong? (khac null, undefined, '', NaN)
  return !(_isNaN(val) || _isNull(val) || val === undefined || val === '')
}
